import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { EXPENSES_MANAGE, holds, useExpensesPermissions } from '../use-expenses-permissions';

/** The list header's «Importa da nexpense»: offered only to holders of `expenses:expense:manage`. */
export function ImportReferenceLink() {
  const { t } = useTranslation('expenses');
  if (!holds(useExpensesPermissions(), EXPENSES_MANAGE)) return null;
  return (
    <Button asChild variant="outline">
      <Link to="/expenses/import">{t('import.link')}</Link>
    </Button>
  );
}
